
class Cache {
  constructor(storage) {
    this.storage = storage
  }
  formatKey(key) {
    return "qj-" + key
  }
  save(key, params) {
    this.storage.setItem(this.formatKey(key), JSON.stringify(params))
  }
  get(key) {
    let value = this.storage.getItem(this.formatKey(key))
    if (value) {
      return JSON.parse(value)
    }
    return null
  }
  saveValue(key,value){
    this.storage.setItem(this.formatKey(key), value)
  }
  getValue(key){
    return this.storage.getItem(this.formatKey(key))
  }
  remove(key){
    this.storage.removeItem(this.formatKey(key));
  }
  clear(){
      this.storage.clear()
  }
}

(function () {
  window.session = new Cache(window.sessionStorage)
  window.local = new Cache(window.localStorage)
})();


